import type { IconSvgObject } from './types';

const ArrowRightFromLineIcon: IconSvgObject = [
  ["path", { d: "M20 12H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 7C15 7 20 10.6824 20 12C20 13.3176 15 17 15 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 7V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowRightFromLineIcon;
